module.exports = __webpack_public_path__ + "83540e660bba8c7ff88ecc64ceb12999.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-right-25.png
// module id = 2705
// module chunks = 0